<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-on="{ ...tooltip, ...dialog }" @click="getItems"><v-icon>add</v-icon> </v-btn>
        </template>
        <span>Add item</span>
      </v-tooltip>
    </template>
    
    <v-card>
      <v-card-title>
        <h2>Add Item</h2>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form class="px-3" ref="form">
            <v-row>
              <v-col>
                <div class="ma-0">
                  <v-icon>shopping_cart</v-icon> {{ cartId }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  class="ma-0"
                  v-model="typeSelected"
                  :items="types"
                  menu-props="auto"
                  label="Select Type"
                  hide-details
                  prepend-icon="map"
                  single-line
                  v-on:change="changeSelectedType"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  class="ma-0"
                  v-model="itemSelected"
                  :items="itemsInType"
                  menu-props="auto"
                  label="Select Item"
                  hide-details
                  prepend-icon="map"
                  single-line
                  v-on:change="changeSelectedItem"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selectedItemDescription"
                  label="Selected Item"
                  prepend-icon="class"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedItemPrice"
                  label="Price"
                  prepend-icon="email"
                  hide-details
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="selectedItemQuantity"
                  label="Quantity"
                  prepend-icon="class"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-btn
                @click="submitAddOrder"
                class="success mx-1 mt-3"
                :loading="loading"
                >Add To Cart</v-btn
              >
              <v-btn
                v-if="newCartenabled"
                @click="getCartId"
                class="success mx-1 mt-3"
                :loading="loading"
                >New cart</v-btn
              >
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";
import { VRow, VCol } from "vuetify/lib";

export default {
  components: {
    VRow,
    VCol
  },
  props: {
    cartId: {
      type: String
    },
    currency: {
      type: String,
      default: 'usd'
    },
    newCartenabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      typeSelected: "",
      itemSelected: "",
      itemToAdd: "",
      items: [],
      itemsInType: [],
      types: [],
      selectedItemPrice: 0,
      selectedItemQuantity: 1,
      selectedItemDescription: "Nothing selected",
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 3 || "Minimum length is 3 characters"
      ],
      loading: false,
      dialog: false
    };
  },
  methods: {
    async getItems() {
      this.items = await cartApi.getAllItems();
      this.types = Array.from(new Set(this.items.map(item => item.type))).sort();
    },
    changeSelectedType() {
      this.itemToAdd = "";
      this.itemSelected = "";
      this.selectedItemPrice = 0;
      this.selectedItemQuntity = 1;
      this.selectedItemDescription = "Nothing selected";
      let itemsInType = this.items.filter(
        item => item.type === this.typeSelected
      );
      this.itemsInType = itemsInType.map(item => item.item).sort();
    },
    changeSelectedItem() {
      this.itemToAdd = this.items.find(item => item.item === this.itemSelected);
      const prices = this.itemToAdd.itemPrices || [];
      const priceObj = prices.find(p => p.currency === this.currency) || prices[0];
      this.selectedItemPrice = priceObj ? priceObj.price : 0;
      this.selectedItemDescription = this.itemToAdd.description;
    },
    async submitAddOrder() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let res = await cartApi.postAddItemToCartAdmin(
          this.cartId,
          this.itemToAdd.item,
          this.selectedItemQuantity,
          this.selectedItemPrice,
          this.currency
        );
        this.loading = false;
        this.dialog = false;
        this.$emit("itemAdded");
        this.$toast("Item " + this.itemToAdd.item + " added");
      }
    },
    getCartId() {
      cartApi.getCartId().then(newCartId => {
        this.cartId = newCartId.cartId;
      });
    }
  }
};
</script>
